import { call } from 'redux-saga/effects';
import { initializeChurnZero } from '../lib';
import { ChurnZeroActionType, ChurnZeroInitializeAction } from './actions';
import { combineAllWatchers, createWatcherSaga, SagaYieldType } from '@sonar-software/xuder';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* initializeChurnZeroSaga(action: ChurnZeroInitializeAction) {
	const { data } = action;

	yield call(initializeChurnZero, data);
}

export const watchInitializeChurnZeroSaga = createWatcherSaga([
	{
		action: ChurnZeroActionType.RequestInitialize,
		actionHandler: initializeChurnZeroSaga,
		type: SagaYieldType.Every
	}
]);

export const churnZeroWatchers = combineAllWatchers([ watchInitializeChurnZeroSaga ]);
